import { GraphQLSingularResponse } from "relay-runtime";

import { HydrationData } from "@framework/relay/shared/hydration";
import Middleware from "@framework/relay/shared/Middleware";
import { isEqual } from "@framework/relay/utils";

/**
 * hydration middleware uses hydration data to serve initial GraphQL requests.
 *
 * @param hydrationData the data we use to serve initial GraphQL requests.
 * @returns a middleware for the relay network layer
 */
const hydrationMiddleware = (hydrationData: HydrationData): Middleware => {
  const responses = [...hydrationData.responses];
  return (next) => (ctx) => {
    if (ctx.request.operationKind !== "query") {
      return next(ctx);
    }

    const idx = responses.findIndex(
      (v) =>
        // Operation name must match.
        v.operationName === ctx.operation.operationName &&
        // Check for matching variables.
        isEqual(v.variables, ctx.operation.variables),
    );
    if (idx === -1) {
      return next(ctx);
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const response = responses[idx]!;

    responses.splice(idx, 1);

    return {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      data: response.data,
      errors: response.errors,
    } as GraphQLSingularResponse;
  };
};

export default hydrationMiddleware;
